<template>
    <div class="dashboard">
        <loading ref="pLoadScreen"/>
        <header-navigation/>
        <div class="container">
            <oops ref="pOops"/>
            <error ref="pError"/>
            <provider-header ref="pHeader"/>
            <div class="providerDashContent">
                <provider-chart-operators ref="pOperators"/>
                <provider-vessels ref="pVessels"/>
                <provider-info ref="pInfo"/>
            </div>
        </div>
        <bottom-credits/>
    </div>
</template>

<script>
import axios from 'axios';
import ProviderHeader from '../components/provider/ProviderHeader.vue';
import ProviderVessels from '../components/provider/ProviderVessels.vue';
import ProviderInfo from '../components/provider/ProviderInfo.vue';
import ProviderChartOperators from '../components/provider/ProviderChartOperators.vue';
import Loading from '../components/Loading.vue';
import BottomCredits from '../components/BottomCredits.vue';
import HeaderNavigation from '../components/HeaderNavigation.vue';
import Error from '../components/Error.vue';
import Oops from '../components/Oops.vue';

export default {
    name: "Provider",
    components: {
        ProviderHeader,
        ProviderVessels,
        ProviderInfo,
        ProviderChartOperators,
        Loading,
        BottomCredits,
        HeaderNavigation,
        Error,
        Oops
    },
    mounted() {
        var globv = this;
        globv.$refs.pLoadScreen.startLoading();
        globv.retrieveProviderData();
    },
    methods: {
        retrieveProviderData: async function() {
            var globv = this;
            let provider = globv.$route.params.provider;
            // console.log(provider);

            try {
                let response = await axios.get('/api/providers/' + provider);
                // console.log(response);
                if (response && response.data) {
                    globv.updateComponentInfo(response.data);
                }
            }
            catch (error) {
                globv.handleError(error);
            }
        },
        updateComponentInfo: function(providerInfo) {
            let globv = this;
            globv.$refs.pHeader.updateInfo(providerInfo['provider']);
            globv.$refs.pVessels.updateInfo(providerInfo['supplyVessels']['vessels']);
            globv.$refs.pInfo.updateInfo(providerInfo);
            globv.$refs.pOperators.createChart(providerInfo['timeSpentPerOperator']);
            setTimeout(globv.$refs.pLoadScreen.finishLoading, 100);
        },
        handleError: function(error) {
            var globv = this;
            // console.log(error, error.response);
            error = error.response.data;
            if (error['error'] && error['error']['status'] < 500) {
                if (error['error']['status'] == 404)
                    globv.$refs.pError.showError({
                        status: 404, 
                        title: "Not Found", 
                        message: error['error']['message']
                    });
                else
                    globv.$refs.pError.showError({
                        status: error['error']['status'],
                        message: error['error']['message']
                    });
            }
            else
                globv.$refs.pOops.showOops();

            setTimeout(globv.$refs.pLoadScreen.finishLoading, 100);
        }
    }
}
</script>

<style lang="scss">
.providerDashContent {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex: 1 0 auto;
    
    & > .card {
         width: 80%;
         max-width: 1200px;
    }

    & .chart {
        height: 50vw;
        max-height: 80vh;
        
        #operatorChart {
            height: 100%;
        }
    }
}

@media (max-width: 1200px) {
    .providerDashContent {
        .chartContent {
            display: flex;
            justify-content: center;
        }

        .chart {
            width: 90vw;
        }

        .card {
            width: 100%;
            margin: 20px 10px;
        }
    }
}

@media (max-width: 935px) {
    .providerDashContent {
        padding: 0;
        
        .card {
            margin: 20px 0;
        }
    }
}

@media (max-width: 420px) {
    .providerDashContent .cardContent {
        padding: 0 10px 10px;
    }
}
</style>